import { render, staticRenderFns } from "./FileViewer.html?vue&type=template&id=2555a2d6&external"
import script from "./FileViewer.ts?vue&type=script&lang=ts&external"
export * from "./FileViewer.ts?vue&type=script&lang=ts&external"
import style0 from "./FileViewer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports